import { render } from "./MonTaskListView.vue?vue&type=template&id=472ce324&scoped=true"
import script from "./MonTaskListView.vue?vue&type=script&lang=js"
export * from "./MonTaskListView.vue?vue&type=script&lang=js"

import "./MonTaskListView.vue?vue&type=style&index=0&id=472ce324&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472ce324"]])

export default __exports__